import React from 'react';
import styles from "./ScreenshotSelectorModal.module.css"
import clsx from 'clsx';
import Screenshot from '../Screenshot';
import { ScreenshotDataModel } from '../../ScreenshotSelector';
import ArrowButton from '../../../ArrowButton';

interface ScreenshotSelectorModalProps {
    screenshots?: ScreenshotDataModel[];
    isOpen?: boolean;
    onClose?: () => void;
    onClickView?: (screenshot: ScreenshotDataModel) => void;
    onClickSelect?: (screenshot: ScreenshotDataModel) => void;
    onSendClicked?: () => void;
}

const ScreenshotSelectorModal: React.FC<ScreenshotSelectorModalProps> = ({
    screenshots,
    isOpen = false,
    onClose,
    onClickView,
    onClickSelect,
    onSendClicked }) => {
    if (!isOpen) return null

    return (
        <div className={styles.modalOverlay} >
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div style={{ flex: 1, flexDirection: "row", display: "flex", gap: "16px" }}>
                    </div>

                    <button className={styles.closeButton} onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className={styles.modalBody}>
                    {screenshots && screenshots.map((url, index) => (
                        <Screenshot key={index} screenshot={url} onClickView={() => { onClickView && onClickView(url) }} onClickSelect={() => { onClickSelect && onClickSelect(url) }} state='normal' />
                    ))}
                </div>
                <div className={styles.modalFooter} >
                    <button className={clsx(styles.button, styles.warning)} onClick={onClose}>
                        Cancel
                    </button>
                    <ArrowButton onClick={onSendClicked} />
                </div>
            </div>
        </div>
    );
};

export default ScreenshotSelectorModal;